import { cn } from "@/lib/utils";

interface IdentityProvidersEmptyProps {
  className?: string;
}

export function IdentityProvidersEmpty({ className }: IdentityProvidersEmptyProps) {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <line
        x1="60"
        y1="60"
        x2="28"
        y2="76"
        style={{ stroke: "hsl(var(--border))" }}
        strokeWidth="1.5"
      />
      <line
        x1="60"
        y1="60"
        x2="92"
        y2="76"
        style={{ stroke: "hsl(var(--border))" }}
        strokeWidth="1.5"
      />
      <circle
        cx="60"
        cy="57"
        r="18"
        style={{ fill: "hsl(var(--muted))", stroke: "hsl(var(--primary))" }}
        strokeWidth="1.5"
      />
      <circle cx="60" cy="52" r="5" style={{ fill: "hsl(var(--primary))" }} />
      <rect
        x="53"
        y="59"
        width="14"
        height="9"
        rx="2"
        style={{ fill: "hsl(var(--primary))" }}
      />
      <circle
        cx="28"
        cy="78"
        r="14"
        style={{
          fill: "hsl(var(--muted))",
          stroke: "hsl(var(--muted-foreground))",
        }}
        strokeWidth="1.5"
      />
      <circle
        cx="28"
        cy="74"
        r="3.5"
        style={{ fill: "hsl(var(--muted-foreground))" }}
      />
      <rect
        x="22.5"
        y="79"
        width="11"
        height="7"
        rx="1.5"
        style={{ fill: "hsl(var(--muted-foreground))" }}
      />
      <circle
        cx="92"
        cy="78"
        r="14"
        style={{
          fill: "hsl(var(--muted))",
          stroke: "hsl(var(--muted-foreground))",
        }}
        strokeWidth="1.5"
      />
      <circle
        cx="92"
        cy="74"
        r="3.5"
        style={{ fill: "hsl(var(--muted-foreground))" }}
      />
      <rect
        x="86.5"
        y="79"
        width="11"
        height="7"
        rx="1.5"
        style={{ fill: "hsl(var(--muted-foreground))" }}
      />
    </svg>
  );
}
